import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { NavController } from '@ionic/angular';

import { SAMSessionService } from './sam/sam-session.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AppGuard implements CanActivate {

  constructor(
    private configSvc: ConfigService,
    private samSessionSvc: SAMSessionService,
    private navCtrl: NavController
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {

    let navigateTo = `/`;

    if (
      next.params && 
      next.params.cfgDeviceId &&
      next.params.cfgFileName
    ) {
      navigateTo = `${next.params.cfgDeviceId}/${next.params.cfgFileName}`;
    }

    if (!this.configSvc.loaded) {
      this.navCtrl.navigateRoot(navigateTo);
      return false;
    }

    if (!this.samSessionSvc.initialized) {
      this.navCtrl.navigateRoot(navigateTo);
      return false;
    }

    return true;
  }
}
